import styles from './SolutionsApproach.module.css'

const approaches = [
  {
    title: 'We start with your problems',
    body: 'We look at how your business actually runs, find what is slowing it down, and design solutions around those specific problems.',
  },
  {
    title: 'AI where it earns its place',
    body: 'We bring AI in when it can genuinely shorten a task or surface useful insight, and leave it out when it would just add noise.',
  },
  {
    title: 'Built to last, built to scale',
    body: "Solutions designed with your business's growth in mind, so what we build today keeps working as you grow.",
  },
]

const SolutionsApproach = () => {
  return (
    <section id="our-approach" className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          <div className={styles.sectionTag}>
            <span className={styles.tagNumber}>02</span>
            <span className={styles.tagLine} />
            <span className={styles.tagText}>Our Approach</span>
          </div>
          <h2 className={styles.title}>How we work with your business</h2>
        </div>

        <div className={styles.grid}>
          {approaches.map((item, i) => (
            <div key={i} className={styles.card}>
              <span className={styles.cardNumber}>{String(i + 1).padStart(2, '0')}</span>
              <h3 className={styles.cardTitle}>{item.title}</h3>
              <p className={styles.cardBody}>{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SolutionsApproach
